// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"31c900c8","229":"950e3f5f","369":"b4201caa","592":"7519814f","727":"b50fa513","787":"d5bcad7a","830":"da82f9df","831":"06c04b64"}[chunkId] + ".chunk.js";
};